module.exports = __webpack_public_path__ + "media/images/course/terminal__-62e2a7a4355d894ee7f7c131a80966c6.png";